<ngx-dynamic-hooks
    class="markdown-content {{ cssClasses() }}"
    [options]="{ sanitize: false, updateOnPushOnly: true }"
    [content]="content() | resizeHtmlImages | stripEmbed: cookiePreferences() || undefined"
    fstrDynamicContent
/>